import React, { Component } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  ImageBackground,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import { LinearGradient } from "expo-linear-gradient";

import { getAluno } from "../../services/aluno-service";
import styles from "./styles";

class RedesSociais extends Component {
  static navigationOptions = ({ navigation }) => {
    return {
      headerStyle: {
        backgroundColor: "#0F0F0F",
      },
      headerTitleStyle: {
        color: "#F1F1F1",
      },
      headerLeft: () => (
        <TouchableOpacity
          onPress={() => {
            navigation.openDrawer();
          }}
        >
          <Icon
            style={styles.iconHeaderLeft}
            name="reorder"
            size={30}
            color="#F1F1F1"
          />
        </TouchableOpacity>
      ),
    };
  };

  constructor(props) {
    super();
    this.state = {
      aluno: {},
    };

    this.listener = EventRegister.addEventListener(
      "reloadRedesSociais",
      async (data) => {
        this.setState({ aluno: await getAluno(true) });
      }
    );
  }

  componentDidMount = async () => {
    this.setState({ aluno: await getAluno() });
  };

  componentWillUnmount = () => {
    EventRegister.removeEventListener(this.listener);
  };

  handlerButtons = (target) => {
    let aluno = this.props.navigation.getParam("aluno");
    this.props.navigation.navigate("InformarRedeSocial", { aluno, target });
  };

  render() {
    const { facebook, instagram, linkedin } = this.state.aluno;

    return (
      <ImageBackground
        source={require("../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <ScrollView showsVerticalScrollIndicator={false}>
          <Text style={styles.textHeader}>
            Aqui estão as suas redes sociais
          </Text>

          <TouchableOpacity
            onPress={() => {
              this.handlerButtons("Facebook");
            }}
            style={[styles.redesContainer]}
          >
            {!facebook && <View style={styles.fade} />}
            <Icon
              name="facebook-square"
              size={40}
              style={{ marginRight: 10 }}
              color="#3B5998"
            />
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {facebook ? (
                <>
                  <Text style={styles.marcador}>@</Text>
                  <Text style={styles.textRedes}>
                    ...{facebook.substr(facebook.lastIndexOf("/"))}
                  </Text>
                </>
              ) : (
                <Text style={styles.textRedes}>Toque para adicionar</Text>
              )}
            </View>
            <Icon
              name="edit"
              size={25}
              color="#C1C1C1"
              style={{ marginLeft: "auto" }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              this.handlerButtons("Instagram");
            }}
            style={[styles.redesContainer]}
          >
            {!instagram && <View style={styles.fade} />}
            <LinearGradient
              start={[0, 1]}
              end={[1, 0]}
              colors={["#f09433", "#e6683c", "#dc2743", "#cc2366", "#bc1888"]}
              style={{
                padding: 4,
                paddingVertical: 2,
                borderRadius: 8,
                marginEnd: 10,
              }}
            >
              <Icon name="instagram" size={34} color="#FFF" />
            </LinearGradient>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {instagram ? (
                <>
                  <Text style={styles.marcador}>@</Text>
                  <Text style={styles.textRedes}>
                    ...{instagram.substr(instagram.lastIndexOf("/"))}
                  </Text>
                </>
              ) : (
                <Text style={styles.textRedes}>Toque para adicionar</Text>
              )}
            </View>
            <Icon
              name="edit"
              size={25}
              color="#C1C1C1"
              style={{ marginLeft: "auto" }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              this.handlerButtons("Linkedin");
            }}
            style={[styles.redesContainer]}
          >
            {!linkedin && <View style={styles.fade} />}
            <Icon
              name="linkedin-square"
              size={40}
              style={{ marginRight: 10 }}
              color="#0e76a8"
            />
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {linkedin ? (
                <>
                  <Text style={styles.marcador}>@</Text>
                  <Text style={styles.textRedes}>
                    ...{linkedin.substr(linkedin.lastIndexOf("/"))}
                  </Text>
                </>
              ) : (
                <Text style={styles.textRedes}>Toque para adicionar</Text>
              )}
            </View>
            <Icon
              name="edit"
              size={25}
              color="#C1C1C1"
              style={{ marginLeft: "auto" }}
            />
          </TouchableOpacity>
        </ScrollView>
      </ImageBackground>
    );
  }
}
export default RedesSociais;
